import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import FlaggedCases from "../Components/FlaggedCases/main";
import {
  fetchPageObject,
  fetchShakespeareStatus,
  getCaseId,
  getClientId,
  setCaseId,
  setClientId,
} from "../Utils/helper";
import Footer from "../Components/common/footer";

const FlaggedCasesPage = () => {
  const [newFlags, setNewFlags] = useState(0);
  const location = useLocation();
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 31).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    const newClientID = location.pathname.split("/")[2];
    const newCaseID = location.pathname.split("/")[3];
    const clientID = getClientId();
    const caseID = getCaseId();

    if (newClientID !== clientID || newCaseID !== caseID) {
      setClientId(newClientID);
      setCaseId(newCaseID);
      // sending page ids directly now.
      fetchShakespeareStatus(newCaseID, 31, dispatch);
    }
  }, [location, dispatch]);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container">
          <div className="top-panel-wrapper" />
          <NavBar flaggedPageName="31" newFlags={newFlags} setNewFlags={setNewFlags} />
          <FlaggedCases newFlags={newFlags} pageObj={pageObject} />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FlaggedCasesPage;
